import React from 'react';
import { Col, Row, Typography } from 'antd';
import styled from 'styled-components';
import { PurpleButton } from '../../../styles/StyledComponents';
import { CheckCircleOutlined, RightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { FormattedMessage, } from 'react-intl';

const { Title } = Typography;

const FeatureTableContainer = styled.div`
  @media (max-width: 1200px) {
    display: none;
  }
`;

export const FeatureTable = () => {
  return (
    <FeatureTableContainer>
      {/* <Table
        dataSource={data}
        columns={columns}
      ></Table> */}
      {/* GET STARTED OPTIONS */}
      <Row align='middle' justify='center' style={{ margin: '20px auto', marginBottom: '40px' }}>
        <Col xl={6} style={{ width: '100%', height: '100%' }} />
        <Col xl={4} style={{ width: '100%', textAlign: 'center' }}>
          {/* <small>Starting at $21/mo</small> */}
          <Title><FormattedMessage id='pricing-header.table.columns.basic'/></Title>
        </Col>
        <Col xl={4} style={{ width: '100%', textAlign: 'center' }}>
          {/* <small>Starting at $49/mo</small> */}
          <Title><FormattedMessage id='pricing-header.table.columns.team'/></Title>
        </Col>
        <Col xl={4} style={{ width: '100%', textAlign: 'center' }}>
          {/* <small>Starting at $149/mo</small> */}
          <Title><FormattedMessage id='pricing-header.table.columns.teamPlus'/></Title>
        </Col>
        {/* <Col xl={4} style={{width: '100%', textAlign: 'center'}}> */}
        {/* <small>Custom Pricing</small> */}
        {/* <Title>Enterprise</Title> */}
        {/* </Col> */}
      </Row>
      {/* FEATURES SECTION */}
      <Row align='middle' justify='center' style={{ height: '4rem' }}>
        <Col
          xl={6}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <Title><FormattedMessage id='pricing-header.table.columns.features'/></Title>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        />
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        />
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        />
        {/* <Col xl={4} style={{width: '100%', height: '100%',borderBottom: '1px solid #ccc'}}> */}
        {/* </Col> */}
      </Row>
      {/* PHONE NUMBERS SECTION */}
      <Row align='middle' justify='center' style={{ height: '4rem' }}>
        <Col
          xl={6}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <Title level={4} style={{ margin: '15px auto' }}><FormattedMessage id='pricing-header.table.rows.phoneNumber'/></Title>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Title level={3} style={{ fontWeight: 'bolder', color: 'purple', margin: '15px auto' }}><FormattedMessage id='pricing-header.table.rows.12'/></Title>
          </div>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Title level={3} style={{ fontWeight: 'bolder', color: 'purple', margin: '15px auto' }}>&infin;</Title>
          </div>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Title level={3} style={{ fontWeight: 'bolder', color: 'purple', margin: '15px auto' }}>&infin;</Title>
          </div>
        </Col>
        {/* <Col xl={4} style={{width: '100%', height: '100%',borderBottom: '1px solid #ccc'}}> */}
        {/* <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}> */}
        {/* <Title level={3} style={{fontWeight: 'bolder', color: 'purple', margin: '15px auto'}}>TBD</Title> */}
        {/* </div> */}
        {/* </Col> */}
      </Row>
      {/* TUTOR GROUPS SECTION */}
      <Row align='middle' justify='center' style={{ height: '4rem' }}>
        <Col
          xl={6}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <Title level={4} style={{ margin: '15px auto' }}><FormattedMessage id='pricing-header.table.rows.tutorGroups'/></Title>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Title level={3} style={{ fontWeight: 'bolder', color: 'purple', margin: '15px auto' }}>&infin;</Title>
          </div>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Title level={3} style={{ fontWeight: 'bolder', color: 'purple', margin: '15px auto' }}>&infin;</Title>
          </div>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Title level={3} style={{ fontWeight: 'bolder', color: 'purple', margin: '15px auto' }}>&infin;</Title>
          </div>
        </Col>
        {/* <Col xl={4} style={{width: '100%', height: '100%',borderBottom: '1px solid #ccc'}}> */}
        {/* <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}> */}
        {/* <Title level={3} style={{fontWeight: 'bolder', color: 'purple', margin: '15px auto'}}>TBD</Title> */}
        {/* </div> */}
        {/* </Col> */}
      </Row>
      {/* CLASSES SECTION */}
      <Row align='middle' justify='center' style={{ height: '4rem' }}>
        <Col
          xl={6}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <Title level={4} style={{ margin: '15px auto' }}><FormattedMessage id='pricing-header.table.rows.classes'/></Title>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Title level={3} style={{ fontWeight: 'bolder', color: 'purple', margin: '15px auto' }}>&infin;</Title>
          </div>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Title level={3} style={{ fontWeight: 'bolder', color: 'purple', margin: '15px auto' }}>&infin;</Title>
          </div>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Title level={3} style={{ fontWeight: 'bolder', color: 'purple', margin: '15px auto' }}>&infin;</Title>
          </div>
        </Col>
        {/* <Col xl={4} style={{width: '100%', height: '100%',borderBottom: '1px solid #ccc'}}> */}
        {/* <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}> */}
        {/* <Title level={3} style={{fontWeight: 'bolder', color: 'purple', margin: '15px auto'}}>TBD</Title> */}
        {/* </div> */}
        {/* </Col> */}
      </Row>
      {/* SCHOLARS SECTION */}
      <Row align='middle' justify='center' style={{ height: '4rem' }}>
        <Col
          xl={6}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <Title level={4} style={{ margin: '15px auto' }}><FormattedMessage id='pricing-header.table.rows.scholars'/></Title>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Title level={3} style={{ fontWeight: 'bolder', color: 'purple', margin: '15px auto' }}>&infin;</Title>
          </div>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Title level={3} style={{ fontWeight: 'bolder', color: 'purple', margin: '15px auto' }}>&infin;</Title>
          </div>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Title level={3} style={{ fontWeight: 'bolder', color: 'purple', margin: '15px auto' }}>&infin;</Title>
          </div>
        </Col>
        {/* <Col xl={4} style={{width: '100%', height: '100%',borderBottom: '1px solid #ccc'}}> */}
        {/* <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}> */}
        {/* <Title level={3} style={{fontWeight: 'bolder', color: 'purple', margin: '15px auto'}}>TBD</Title> */}
        {/* </div> */}
        {/* </Col> */}
      </Row>
      {/* ADMIN USERS SECTION */}
      <Row align='middle' justify='center' style={{ height: '4rem' }}>
        <Col
          xl={6}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <Title level={4} style={{ margin: '15px auto' }}><FormattedMessage id='pricing-header.table.rows.adminUsers'/></Title>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        />
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CheckCircleOutlined style={{ fontSize: 30, color: 'purple', margin: '15px auto' }} />
          </div>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CheckCircleOutlined style={{ fontSize: 30, color: 'purple', margin: '15px auto' }} />
          </div>
        </Col>
        {/* <Col xl={4} style={{width: '100%', height: '100%',borderBottom: '1px solid #ccc'}}> */}
        {/* <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}> */}
        {/* <CheckCircleOutlined style={{fontSize: 30, color: 'purple', margin: '15px auto'}} /> */}
        {/* </div> */}
        {/* </Col> */}
      </Row>
      {/* VANITY NUMBERS SECTION */}
      <Row align='middle' justify='center' style={{ height: '4rem' }}>
        <Col
          xl={6}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <Title level={4} style={{ margin: '15px auto' }}><FormattedMessage id='pricing-header.table.rows.vanityNumbers'/></Title>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        />
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        />
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CheckCircleOutlined style={{ fontSize: 30, color: 'purple', margin: '15px auto' }} />
          </div>
        </Col>
        {/* <Col xl={4} style={{width: '100%', height: '100%',borderBottom: '1px solid #ccc'}}> */}
        {/* <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}> */}
        {/* <CheckCircleOutlined style={{fontSize: 30, color: 'purple', margin: '15px auto'}} /> */}
        {/* </div> */}
        {/* </Col> */}
      </Row>
      {/* ADVANCED METRICS SECTION */}
      <Row align='middle' justify='center' style={{ height: '4rem' }}>
        <Col
          xl={6}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <Title level={4} style={{ margin: '15px auto' }}><FormattedMessage id='pricing-header.table.rows.advancedMetrics'/></Title>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        />
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        />
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CheckCircleOutlined style={{ fontSize: 30, color: 'purple', margin: '15px auto' }} />
          </div>
        </Col>
        {/* <Col xl={4} style={{width: '100%', height: '100%',borderBottom: '1px solid #ccc'}}> */}
        {/* <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}> */}
        {/* <CheckCircleOutlined style={{fontSize: 30, color: 'purple', margin: '15px auto'}} /> */}
        {/* </div> */}
        {/* </Col> */}
      </Row>
      {/* QUESTION SET PRIORITY SECTION */}
      <Row align='middle' justify='center' style={{ height: '4rem' }}>
        <Col
          xl={6}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <Title level={4} style={{ margin: '15px auto' }}><FormattedMessage id='pricing-header.table.rows.questionSetPriority'/></Title>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Title level={4} style={{ fontWeight: 'bolder', color: 'purple', margin: '15px auto' }}><FormattedMessage id='pricing-header.table.rows.publicPrivate'/></Title>
          </div>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Title
              level={4}
              style={{ fontWeight: 'bolder', color: 'purple', margin: '15px auto' }}
            >Public/Private/Team
            </Title>
          </div>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Title
              level={4}
              style={{ fontWeight: 'bolder', color: 'purple', margin: '15px auto' }}
            ><FormattedMessage id='pricing-header.table.rows.publicPrivateTeam'/>
            </Title>
          </div>
        </Col>
        {/* <Col xl={4} style={{width: '100%', height: '100%',borderBottom: '1px solid #ccc'}}> */}
        {/* <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}> */}
        {/* <Title level={4} style={{fontWeight: 'bolder', color: 'purple', margin: '15px auto'}}>Public/Private/Team</Title> */}
        {/* </div> */}
        {/* </Col> */}
      </Row>
      {/* ORG INSIGHTS SECTION */}
      <Row align='middle' justify='center' style={{ height: '4rem' }}>
        <Col
          xl={6}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <Title level={4} style={{ margin: '15px auto' }}><FormattedMessage id='pricing-header.table.rows.orgInsights'/></Title>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        />
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CheckCircleOutlined style={{ fontSize: 30, color: 'purple', margin: '15px auto' }} />
          </div>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CheckCircleOutlined style={{ fontSize: 30, color: 'purple', margin: '15px auto' }} />
          </div>
        </Col>
        {/* <Col xl={4} style={{width: '100%', height: '100%',borderBottom: '1px solid #ccc'}}> */}
        {/* <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}> */}
        {/* <CheckCircleOutlined style={{fontSize: 30, color: 'purple', margin: '15px auto'}} /> */}
        {/* </div> */}
        {/* </Col> */}
      </Row>
      {/* ADMIN OVERSIGHTS SECTION */}
      <Row align='middle' justify='center' style={{ height: '4rem' }}>
        <Col
          xl={6}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <Title level={4} style={{ margin: '15px auto' }}><FormattedMessage id='pricing-header.table.rows.adminOversight'/></Title>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        />
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CheckCircleOutlined style={{ fontSize: 30, color: 'purple', margin: '15px auto' }} />
          </div>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CheckCircleOutlined style={{ fontSize: 30, color: 'purple', margin: '15px auto' }} />
          </div>
        </Col>
        {/* <Col xl={4} style={{width: '100%', height: '100%',borderBottom: '1px solid #ccc'}}> */}
        {/* <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}> */}
        {/* <CheckCircleOutlined style={{fontSize: 30, color: 'purple', margin: '15px auto'}} /> */}
        {/* </div> */}
        {/* </Col> */}
      </Row>
      {/* ROSTERING SECTION */}
      <Row align='middle' justify='center' style={{ height: '4rem' }}>
        <Col
          xl={6}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <Title level={4} style={{ margin: '15px auto' }}><FormattedMessage id='pricing-header.table.rows.rostering'/></Title>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        />
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        />
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        />
        {/* <Col xl={4} style={{width: '100%', height: '100%',borderBottom: '1px solid #ccc'}}> */}
        {/* <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}> */}
        {/* <CheckCircleOutlined style={{fontSize: 30, color: 'purple', margin: '15px auto'}} /> */}
        {/* </div> */}
        {/* </Col> */}
      </Row>
      {/* lms integration SECTION */}
      <Row align='middle' justify='center' style={{ height: '4rem' }}>
        <Col
          xl={6}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <Title level={4} style={{ margin: '15px auto' }}><FormattedMessage id='pricing-header.table.rows.lmsIntegration'/></Title>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        />
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        />
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        />
        {/* <Col xl={4} style={{width: '100%', height: '100%',borderBottom: '1px solid #ccc'}}> */}
        {/* <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}> */}
        {/* <CheckCircleOutlined style={{fontSize: 30, color: 'purple', margin: '15px auto'}} /> */}
        {/* </div> */}
        {/* </Col> */}
      </Row>
      {/* ROLE BASED ACCESS RULES SECTION */}
      <Row align='middle' justify='center' style={{ height: '4rem' }}>
        <Col
          xl={6}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <Title level={4} style={{ margin: '15px auto' }}><FormattedMessage id='pricing-header.table.rows.roleBasedRules'/></Title>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        />
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CheckCircleOutlined style={{ fontSize: 30, color: 'purple', margin: '15px auto' }} />
          </div>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CheckCircleOutlined style={{ fontSize: 30, color: 'purple', margin: '15px auto' }} />
          </div>
        </Col>
        {/* <Col xl={4} style={{width: '100%', height: '100%',borderBottom: '1px solid #ccc'}}> */}
        {/* <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}> */}
        {/* <CheckCircleOutlined style={{fontSize: 30, color: 'purple', margin: '15px auto'}} /> */}
        {/* </div> */}
        {/* </Col> */}
      </Row>
      {/* STUDENT PROFILE SECTION */}
      <Row align='middle' justify='center' style={{ height: '4rem' }}>
        <Col
          xl={6}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <Title level={4} style={{ margin: '15px auto' }}><FormattedMessage id='pricing-header.table.rows.studentProfile'/></Title>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CheckCircleOutlined style={{ fontSize: 30, color: 'purple', margin: '15px auto' }} />
          </div>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CheckCircleOutlined style={{ fontSize: 30, color: 'purple', margin: '15px auto' }} />
          </div>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CheckCircleOutlined style={{ fontSize: 30, color: 'purple', margin: '15px auto' }} />
          </div>
        </Col>
        {/* <Col xl={4} style={{width: '100%', height: '100%',borderBottom: '1px solid #ccc'}}> */}
        {/* <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}> */}
        {/* <CheckCircleOutlined style={{fontSize: 30, color: 'purple', margin: '15px auto'}} /> */}
        {/* </div> */}
        {/* </Col> */}
      </Row>
      {/* EDUCATOR PROFILE SECTION */}
      <Row align='middle' justify='center' style={{ height: '4rem' }}>
        <Col
          xl={6}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <Title level={4} style={{ margin: '15px auto' }}><FormattedMessage id='pricing-header.table.rows.educatorProfile'/></Title>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        />
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CheckCircleOutlined style={{ fontSize: 30, color: 'purple', margin: '15px auto' }} />
          </div>
        </Col>
        <Col
          xl={4}
          style={{ width: '100%', height: '100%', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CheckCircleOutlined style={{ fontSize: 30, color: 'purple', margin: '15px auto' }} />
          </div>
        </Col>
        {/* <Col xl={4} style={{width: '100%', height: '100%',borderBottom: '1px solid #ccc'}}> */}
        {/* <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}> */}
        {/* <CheckCircleOutlined style={{fontSize: 30, color: 'purple', margin: '15px auto'}} /> */}
        {/* </div> */}
        {/* </Col> */}
      </Row>
      {/* GET STARTED BUTTONS */}
      <Row align='middle' justify='center' style={{ margin: '20px auto', marginBottom: '40px' }}>
        <Col xl={6} style={{ width: '100%', height: '100%' }} />
        <Col xl={4} style={{ width: '100%', textAlign: 'center' }}>
          <Link to='/sign-up'>
            <PurpleButton>
              <FormattedMessage id='pricing-header.get-started-link'/> <RightOutlined />
            </PurpleButton>
          </Link>
        </Col>
        <Col xl={4} style={{ width: '100%', textAlign: 'center' }}>
          <Link to='/contact'>
            <PurpleButton>
              <FormattedMessage id='shared-button.contact-us-link'/> <RightOutlined />
            </PurpleButton>
          </Link>
        </Col>
        <Col xl={4} style={{ width: '100%', textAlign: 'center' }}>
          <Link to='/contact'>
            <PurpleButton>
              <FormattedMessage id='shared-button.contact-us-link'/> <RightOutlined />
            </PurpleButton>
          </Link>
        </Col>
        {/* <Col xl={4} style={{width: '100%', textAlign: 'center'}}> */}
        {/* <PurpleButton>CONTACT SALES</PurpleButton> */}
        {/* </Col> */}
      </Row>
    </FeatureTableContainer>
  );
};
